export enum ImagenActionType {
	// Upload actions
	UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST',
	UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS',
	UPLOAD_IMAGE_FAILURE = 'UPLOAD_IMAGE_FAILURE',

	// Generate actions
	GENERATE_RENDER_REQUEST = 'GENERATE_RENDER_REQUEST',
	GENERATE_RENDER_SUCCESS = 'GENERATE_RENDER_SUCCESS',
	GENERATE_RENDER_FAILURE = 'GENERATE_RENDER_FAILURE',
	CLEAR_GENERATED_RENDER = 'CLEAR_GENERATED_RENDER'
}
